import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

const IdentityContainer = styled(Stack)(({ theme }) => ({
    minHeight: '100%',
    padding: theme.spacing(2),
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
}));

export default IdentityContainer;